// RepulpWasteActionMenu.jsx
import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";

import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";

const RepulpWasteActionMenu = ({
  isEdit,
  onSave,
  onDelete,
  onClear,
  onExit,
  saveDisabled,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleClick = (btn) => {
    setSelectedButton(btn);

    switch (btn) {
      case "save":
        onSave?.();
        break;

      case "delete":
        onDelete?.();
        break;

      case "clear":
        onClear?.();
        break;

      case "exit":
        onExit?.();
        break;

      default:
        break;
    }
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      padding={0}
    >
      {/* Title */}
      <Grid item>
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            width: "100%",
            marginLeft: "10px",
            alignItems: "center",
          }}
        >
          {isEdit ? "Edit Repulp Waste Entry" : "New Repulp Waste Entry"}
        </Typography>
      </Grid>

      {/* Action Buttons */}
      <Grid item>
        <Grid container alignItems="center">
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* SAVE */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Save Entry">
              <IconButton
                onClick={() => handleClick("save")}
                sx={{ display: "flex", alignItems: "center" }}
                disabled={saveDisabled}
              >
                <SaveAltIcon
                  style={{
                    fontSize: "18px",
                    color:
                      selectedButton === "save"
                        ? "yellow"
                        : "#009688", // same teal color from reference
                  }}
                />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Save
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          {/* DELETE (only when editing) */}
          {isEdit && (
            <>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

              <Grid item ml={1} mr={1}>
                <Tooltip title="Delete Entry">
                  <IconButton
                    onClick={() => handleClick("delete")}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <DeleteIcon
                      style={{
                        fontSize: "18px",
                        color: "#d72c0dff", // same red as reference
                      }}
                    />
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      Delete
                    </Typography>
                  </IconButton>
                </Tooltip>
              </Grid>
            </>
          )}

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* CLEAR */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Clear All Fields">
              <IconButton
                onClick={() => handleClick("clear")}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <ClearAllIcon
                  style={{
                    fontSize: "18px",
                    color: "#e0d620ff", // yellow tone from reference
                  }}
                />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Clear
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* EXIT */}
          <Tooltip title="Close Form">
            <IconButton onClick={() => handleClick("exit")}>
              <CloseIcon style={{ fontSize: "14px", color: "#2196F3" }} />
            </IconButton>
          </Tooltip>

          <Divider orientation="vertical" flexItem />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RepulpWasteActionMenu;
